module.exports = __webpack_public_path__ + "static/media/Sinkiat1.930805e0.svg";